/** A list with at least one item, which a read of "none of them" cannot be spelled as. */
export type NonEmpty<T> = readonly [T, ...T[]];

function isNonEmpty<T>(list: readonly T[]): list is NonEmpty<T> {
  return list.length > 0;
}

/** The list as a non-empty one, or null when it holds nothing. */
export function nonEmptyOf<T>(list: readonly T[]): NonEmpty<T> | null {
  return isNonEmpty(list) ? list : null;
}

export function mapNonEmpty<T, U>([first, ...rest]: NonEmpty<T>, f: (item: T) => U): NonEmpty<U> {
  return [f(first), ...rest.map(f)];
}
